export default __webpack_public_path__ + "media/images/halloween/spiderweb-e6ab2f48f933aa7aaba07c384d42a877.svg";